// volt-2027 core: the bits of the showcase's shell.js the theme needs. Shopify
// renders each language itself, so setLang/onLang are no-ops here.
(function () {
  // Shrink each title until its real text ends inside the right margin.
  // CSS wrapping alone was not enough: a long name that fits the box can still
  // run past the margin, so this measures the glyphs with a Range.
  function fit(selector, marginVar) {
    const m = parseFloat(getComputedStyle(document.documentElement).getPropertyValue(marginVar)) || 20;
    const maxRight = innerWidth - m;
    document.querySelectorAll(selector).forEach(el => {
      el.style.fontSize = '';
      const r = document.createRange(); r.selectNodeContents(el);
      let fs = parseFloat(getComputedStyle(el).fontSize), box = r.getBoundingClientRect();
      if (!box.width) return;                       // hidden right now; fitted when shown
      while (box.right > maxRight && fs > 18) {
        fs *= .95; el.style.fontSize = fs + 'px'; box = r.getBoundingClientRect();
      }
    });
  }
  const lang = document.documentElement.lang || 'da';
  window.VOLT = { fit, lang, setLang() {}, onLang() {}, t: () => ({}) };
})();
